export default __webpack_public_path__ + "static/contactHero-d1533cf8fae10ed021c105e32c0405d2.webp";